import type { User } from '@mss_creator/shared';

export type LandingTarget =
  | { to: '/' }
  | { to: '/companies/$companyId'; params: { companyId: string } };

/**
 * Where `/`'s loader sends the current user (BUILD-735). `pms_user`/
 * `pms_admin` always land on the company grid (fully open — see
 * docs/design/.../2026-08-06 grill-me decisions) since they are global roles,
 * not tied to a single company. A `user`/`admin` with a resolved membership
 * skips straight to their company's space; with none (the only reachable
 * case today, since no bootstrap flow can create one yet) falls back to the
 * grid rather than erroring.
 */
export function resolveLanding(user: User, membershipCompanyId: string | null): LandingTarget {
  if ((user.role === 'user' || user.role === 'admin') && membershipCompanyId) {
    return { to: '/companies/$companyId', params: { companyId: membershipCompanyId } };
  }
  return { to: '/' };
}
